require('../../modules/es6.array.of');
module.exports = require('../../modules/_core').Array.of;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/of.js
// module id = 783
// module chunks = 14